import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  attributeItemWrapper: {
    display: "flex",
    flexDirection: "row",
    margin: "5px",
    borderRadius: "12px",
  },
  attributeItemLabel: {
    backgroundColor: theme.palette.primary.primary200,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "1rem",
    padding: "5px 0 5px 13px",
    borderRadius: "12px 0 0 12px",
    boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
    width: "auto",
  },
  attributeName: {
    fontSize: "14px",
    color: "#373534",
    fontWeight: 700,
    fontFamily: "Inter",
    padding: "2px 13px 2px 0px",
    flex: 1,
  },

  attributeItemValues: {
    padding: ".1rem 1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "0 12px 12px 0",
    boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
    flex: 1,
  },
  shownValues: {
    fontSize: "12px",
    color: theme.palette.black.dark,
    display: "flex",
    alignItems: "center",
    flex: 1,
    padding: "0 10px"
  },
  attributeItemValuesEdit: {
    marginLeft: "4px",
  },
  placeholderValue: {
    color: "#9A9AAF",
    fontSize: '14px'
  },
  requieredInfos: {
    color: "#CC0001",
    fontSize: "12px",
    fontWeight: 400,
    marginLeft: "7px",
    marginBottom: "7px",
  },
}));

export default useStyles;
